import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import { useDispatch, useSelector } from 'react-redux'
import { Card } from '../../components/card/card'
import { getListStatistik } from '../../redux/action/summaryAction'
import { useParams } from 'react-router-dom'
import { CardBody, CardHeader } from 'react-bootstrap'
import { InputNonForm, SelectNonForm } from '../../components/InputComponent'
import moment from 'moment'

const Line = () => {
    const dispatch = useDispatch()
    const { dataStatistik } = useSelector((state) => state.summary)
    const [newLine, setNewLine] = useState([])
    const [filterStartDate, setFilterStartDate] = useState(moment().format('YYYY-MM-DD'))
    const [filterEndDate, setFilterEndDate] = useState(moment().format('YYYY-MM-DD'))
    const { user } = useSelector((state) => state.auth)
    let { siteId } = useParams()
    const param = { 
      token: user.access_token,
      siteId : siteId,
      filter : {
      startDate: filterStartDate,
      endDate: filterEndDate,
    }
     }
       
    // const sortingLine = () => {
    //   let no = []
    //   dataLine.map((key, index) => {
    //     let split = key.regionalId.split('0')
    //     no.push(split[1])
    //   })
    //   let noSorting = no.sort((a, b) => a - b)
    //   let arr = []
    //   for (let i = 1; i <= noSorting.length; i++) {
    //     let regId = 'REG0' + i
    //     arr.push(dataLine.find((e) => e.regionalId === regId))
    //   }
    //   setNewLine(arr)
    // }
    useEffect(() => {
      dispatch(getListStatistik(param));
    }, [filterStartDate, filterEndDate,])
    const onChange = async (e, field) => {
      // console.log(e.target.value)
      if (field === 'startDate') {
        setFilterStartDate(e.target.value)
      }
      if (field === 'endDate') {
        setFilterEndDate(e.target.value)
      }
    }
    
    const seriesData = [];
    const categories = [];

    dataStatistik.forEach(item => {
      const date = item.date;
      const time = item.time;
      const sum = item.sum;

      // Membuat kategori waktu (time) jika belum ada
      if (!categories.includes(time)) {
        categories.push(time);
      }

      // Membuat atau menambahkan data seri berdasarkan tanggal (date)
      const dataIndex = seriesData.findIndex(series => series.name === date);
      if (dataIndex !== -1) {
        seriesData[dataIndex].data.push(sum);
      } else {
        seriesData.push({
          name: date,
          data: [sum]
        });
      }
    });
    // const series = [
    //   {
    //     name: 'Pengguna JPO',
    //     type: 'line',
    //     data: dataStatistik.map((key, index) => key.sum),
    //   },
    // ]
    const options = {
      chart: {
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      colors: ['white', '#ffc2c2', '#ff5e5e'],
      dataLabels: {
        enabled: false,
        fill: {
          colors: ['white', '#ffc2c2', '#ff5e5e'],
        },
      },
      stroke: {
        curve: 'smooth',
        width: '3',
        dashArray: [0],
      },
  
      markers: {
        size: 5,
        colors: ['white', '#ffc2c2', '#ff5e5e'],
        style: {
          colors: ['white', '#ffc2c2', '#ff5e5e'],
        },
      },
      xaxis: {
        categories: dataStatistik.map((key, index) => key.time),
        labels: {
          show: true,
          style: {
            colors: '#fff',
          },
        },
        title: {
          text: 'Pengguna JPO',
          style: {
            color: '#FFFFFF',
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            color: 'white',
          },
        },
      },
  
      fill: {
        type: 'gradient',
        opacity: [1],
        color: '#ffffff',
      },
  
      legend: {
        position: 'top',
        color: 'white',
        horizontalAlign: 'right',
        labels: {
          colors: 'white',
          useSeriesColors: false,
        },
      },
    }
  
    return (
      <Card className="mb-3">
        <CardHeader> 
          <div className='row'>
            <div className='col-xl-8 col-lg-8'>
              <span className="flex-grow-1 fs-15px"> 
                GRAFIK PENGGUNA JPO (PER-JAM)
              </span>
            </div>
            <div className="col-xl-2 col-lg-12">
              <InputNonForm
                type="date"
                placeholder="Title"
                value={filterStartDate}
                onChange={(e) => onChange(e, 'startDate')}
                style={{ width: '100%' }}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-xl-2 col-lg-12">
            <InputNonForm
                type="date"
                placeholder="Title"
                value={filterEndDate}
                onChange={(e) => onChange(e, 'endDate')}
                style={{ width: '100%' }}
                className="form-control form-control-sm"
              />
            </div>
          </div>
        </CardHeader>
        <CardBody>
          <ReactApexChart
            options={options}
            series={seriesData}
            height="267"
            type="line"
            className="apex-charts"
          />
        </CardBody>
      </Card>
    )
  }
  
  export default Line